/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React from 'react';
import { Modal, Button, Image } from 'antd';

export default function TransactionTutorial({ visible, onClose }) {
  return (
    <Modal
      title="Tutorial - Transações"
      onCancel={onClose}
      style={{ maxWidth: '900px' }}
      visible={visible}
      centered
      width="90%"
      footer={[
        <Button key="back" onClick={onClose}>
          Fechar
        </Button>,
      ]}
    >
      <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '@import url(https://themes.googleusercontent.com/fonts/css?kit=3qINvnjb346LubKDfLRn6_esZW2xOQ-xsNqO47m55DA);ul.lst-kix_xzhajfx04av1-3{list-style-type:none}ul.lst-kix_xzhajfx04av1-2{list-style-type:none}ul.lst-kix_xzhajfx04av1-5{list-style-type:none}ul.lst-kix_xzhajfx04av1-4{list-style-type:none}ul.lst-kix_xzhajfx04av1-7{list-style-type:none}ul.lst-kix_xzhajfx04av1-6{list-style-type:none}ul.lst-kix_xzhajfx04av1-8{list-style-type:none}.lst-kix_eqnb7ujsk1ph-0>li{counter-increment:lst-ctn-kix_eqnb7ujsk1ph-0}ul.lst-kix_xzhajfx04av1-1{list-style-type:none}ul.lst-kix_xzhajfx04av1-0{list-style-type:none}ul.lst-kix_9jjzf7tnl3tp-1{list-style-type:none}ul.lst-kix_9jjzf7tnl3tp-0{list-style-type:none}ul.lst-kix_9jjzf7tnl3tp-5{list-style-type:none}ul.lst-kix_9jjzf7tnl3tp-4{list-style-type:none}ul.lst-kix_9jjzf7tnl3tp-3{list-style-type:none}ul.lst-kix_9jjzf7tnl3tp-2{list-style-type:none}ul.lst-kix_9jjzf7tnl3tp-8{list-style-type:none}ul.lst-kix_9jjzf7tnl3tp-7{list-style-type:none}ul.lst-kix_9jjzf7tnl3tp-6{list-style-type:none}ul.lst-kix_lq8kuz2kjaxt-6{list-style-type:none}ul.lst-kix_lq8kuz2kjaxt-7{list-style-type:none}ul.lst-kix_lq8kuz2kjaxt-4{list-style-type:none}ul.lst-kix_lq8kuz2kjaxt-5{list-style-type:none}ul.lst-kix_lq8kuz2kjaxt-2{list-style-type:none}ul.lst-kix_lq8kuz2kjaxt-3{list-style-type:none}ul.lst-kix_lq8kuz2kjaxt-0{list-style-type:none}ul.lst-kix_lq8kuz2kjaxt-1{list-style-type:none}ul.lst-kix_2qpriag06n47-1{list-style-type:none}ul.lst-kix_2qpriag06n47-0{list-style-type:none}ul.lst-kix_2qpriag06n47-3{list-style-type:none}ul.lst-kix_2qpriag06n47-2{list-style-type:none}.lst-kix_eqnb7ujsk1ph-7>li{counter-increment:lst-ctn-kix_eqnb7ujsk1ph-7}ul.lst-kix_lq8kuz2kjaxt-8{list-style-type:none}ul.lst-kix_bpw8b05xh6bg-0{list-style-type:none}ul.lst-kix_bpw8b05xh6bg-1{list-style-type:none}ul.lst-kix_bpw8b05xh6bg-2{list-style-type:none}ul.lst-kix_bpw8b05xh6bg-3{list-style-type:none}ul.lst-kix_bpw8b05xh6bg-4{list-style-type:none}ul.lst-kix_bpw8b05xh6bg-5{list-style-type:none}ul.lst-kix_bpw8b05xh6bg-6{list-style-type:none}ul.lst-kix_bpw8b05xh6bg-7{list-style-type:none}ul.lst-kix_bpw8b05xh6bg-8{list-style-type:none}ul.lst-kix_2qpriag06n47-8{list-style-type:none}ul.lst-kix_2qpriag06n47-5{list-style-type:none}ul.lst-kix_2qpriag06n47-4{list-style-type:none}ul.lst-kix_2qpriag06n47-7{list-style-type:none}ul.lst-kix_2qpriag06n47-6{list-style-type:none}.lst-kix_bpw8b05xh6bg-5>li:before{content:"\\0025a0   "}.lst-kix_eqnb7ujsk1ph-0>li:before{content:"" counter(lst-ctn-kix_eqnb7ujsk1ph-0,decimal) ". "}.lst-kix_bpw8b05xh6bg-3>li:before{content:"\\0025cf   "}.lst-kix_bpw8b05xh6bg-7>li:before{content:"\\0025cb   "}.lst-kix_eqnb7ujsk1ph-2>li:before{content:"" counter(lst-ctn-kix_eqnb7ujsk1ph-2,lower-roman) ". "}ul.lst-kix_fa9p7061r0a4-0{list-style-type:none}ul.lst-kix_fa9p7061r0a4-1{list-style-type:none}ul.lst-kix_fa9p7061r0a4-8{list-style-type:none}ul.lst-kix_fa9p7061r0a4-6{list-style-type:none}ul.lst-kix_fa9p7061r0a4-7{list-style-type:none}ul.lst-kix_fa9p7061r0a4-4{list-style-type:none}ul.lst-kix_fa9p7061r0a4-5{list-style-type:none}ul.lst-kix_fa9p7061r0a4-2{list-style-type:none}ul.lst-kix_fa9p7061r0a4-3{list-style-type:none}ol.lst-kix_eqnb7ujsk1ph-3.start{counter-reset:lst-ctn-kix_eqnb7ujsk1ph-3 0}ol.lst-kix_eqnb7ujsk1ph-6.start{counter-reset:lst-ctn-kix_eqnb7ujsk1ph-6 0}.lst-kix_1ep0gewysvhg-8>li:before{content:"\\0025a0   "}.lst-kix_qiqwh2x6bomx-8>li:before{content:"\\0025a0   "}.lst-kix_eqnb7ujsk1ph-6>li:before{content:"" counter(lst-ctn-kix_eqnb7ujsk1ph-6,decimal) ". "}.lst-kix_eqnb7ujsk1ph-8>li:before{content:"" counter(lst-ctn-kix_eqnb7ujsk1ph-8,lower-roman) ". "}.lst-kix_lq8kuz2kjaxt-6>li:before{content:"\\0025cf   "}.lst-kix_qiqwh2x6bomx-6>li:before{content:"\\0025cf   "}.lst-kix_bpw8b05xh6bg-1>li:before{content:"\\0025cb   "}.lst-kix_eqnb7ujsk1ph-4>li:before{content:"" counter(lst-ctn-kix_eqnb7ujsk1ph-4,lower-latin) ". "}.lst-kix_lq8kuz2kjaxt-4>li:before{content:"\\0025cb   "}ol.lst-kix_eqnb7ujsk1ph-5.start{counter-reset:lst-ctn-kix_eqnb7ujsk1ph-5 0}.lst-kix_qiqwh2x6bomx-0>li:before{content:"\\0025cf   "}.lst-kix_l7q7w09zmg89-1>li:before{content:"\\0025cb   "}.lst-kix_l7q7w09zmg89-3>li:before{content:"\\0025cf   "}.lst-kix_qiqwh2x6bomx-2>li:before{content:"\\0025a0   "}.lst-kix_lq8kuz2kjaxt-2>li:before{content:"\\0025a0   "}.lst-kix_1ep0gewysvhg-2>li:before{content:"\\0025a0   "}.lst-kix_eqnb7ujsk1ph-8>li{counter-increment:lst-ctn-kix_eqnb7ujsk1ph-8}.lst-kix_9jjzf7tnl3tp-5>li:before{content:"\\0025a0   "}ol.lst-kix_eqnb7ujsk1ph-5{list-style-type:none}ol.lst-kix_eqnb7ujsk1ph-4{list-style-type:none}.lst-kix_qiqwh2x6bomx-4>li:before{content:"\\0025cb   "}ol.lst-kix_eqnb7ujsk1ph-3{list-style-type:none}ol.lst-kix_eqnb7ujsk1ph-2{list-style-type:none}ol.lst-kix_eqnb7ujsk1ph-8{list-style-type:none}.lst-kix_lq8kuz2kjaxt-0>li:before{content:"\\0025cf   "}.lst-kix_1ep0gewysvhg-0>li:before{content:"  "}ol.lst-kix_eqnb7ujsk1ph-7{list-style-type:none}.lst-kix_9jjzf7tnl3tp-7>li:before{content:"\\0025cb   "}ol.lst-kix_eqnb7ujsk1ph-6{list-style-type:none}ul.lst-kix_nioq1cjfzb45-7{list-style-type:none}ul.lst-kix_nioq1cjfzb45-8{list-style-type:none}ul.lst-kix_nioq1cjfzb45-5{list-style-type:none}.lst-kix_1ep0gewysvhg-6>li:before{content:"\\0025cf   "}ul.lst-kix_nioq1cjfzb45-6{list-style-type:none}ul.lst-kix_nioq1cjfzb45-3{list-style-type:none}ul.lst-kix_qiqwh2x6bomx-3{list-style-type:none}ul.lst-kix_nioq1cjfzb45-4{list-style-type:none}ul.lst-kix_qiqwh2x6bomx-4{list-style-type:none}ul.lst-kix_nioq1cjfzb45-1{list-style-type:none}ul.lst-kix_qiqwh2x6bomx-5{list-style-type:none}ul.lst-kix_nioq1cjfzb45-2{list-style-type:none}ul.lst-kix_qiqwh2x6bomx-6{list-style-type:none}.lst-kix_vq1lst5ovebp-3>li:before{content:"\\0025cf   "}ul.lst-kix_qiqwh2x6bomx-7{list-style-type:none}ul.lst-kix_nioq1cjfzb45-0{list-style-type:none}ul.lst-kix_qiqwh2x6bomx-8{list-style-type:none}.lst-kix_1ep0gewysvhg-4>li:before{content:"\\0025cb   "}.lst-kix_vq1lst5ovebp-5>li:before{content:"\\0025a0   "}.lst-kix_vq1lst5ovebp-7>li:before{content:"\\0025cb   "}ul.lst-kix_qiqwh2x6bomx-0{list-style-type:none}ol.lst-kix_eqnb7ujsk1ph-4.start{counter-reset:lst-ctn-kix_eqnb7ujsk1ph-4 0}ul.lst-kix_qiqwh2x6bomx-1{list-style-type:none}ul.lst-kix_qiqwh2x6bomx-2{list-style-type:none}ul.lst-kix_vq1lst5ovebp-3{list-style-type:none}ul.lst-kix_vq1lst5ovebp-4{list-style-type:none}ul.lst-kix_vq1lst5ovebp-5{list-style-type:none}ul.lst-kix_vq1lst5ovebp-6{list-style-type:none}ul.lst-kix_vq1lst5ovebp-7{list-style-type:none}ul.lst-kix_vq1lst5ovebp-8{list-style-type:none}ul.lst-kix_vq1lst5ovebp-0{list-style-type:none}ul.lst-kix_vq1lst5ovebp-1{list-style-type:none}.lst-kix_9jjzf7tnl3tp-1>li:before{content:"\\0025cb   "}ul.lst-kix_vq1lst5ovebp-2{list-style-type:none}.lst-kix_9jjzf7tnl3tp-3>li:before{content:"\\0025cf   "}.lst-kix_eqnb7ujsk1ph-2>li{counter-increment:lst-ctn-kix_eqnb7ujsk1ph-2}.lst-kix_2qpriag06n47-0>li:before{content:"\\0025cf   "}.lst-kix_2qpriag06n47-1>li:before{content:"\\0025cb   "}.lst-kix_tplutrsqd04i-8>li:before{content:"\\0025a0   "}.lst-kix_2qpriag06n47-3>li:before{content:"\\0025cf   "}.lst-kix_2qpriag06n47-4>li:before{content:"\\0025cb   "}.lst-kix_2qpriag06n47-5>li:before{content:"\\0025a0   "}.lst-kix_tplutrsqd04i-6>li:before{content:"\\0025cf   "}.lst-kix_tplutrsqd04i-7>li:before{content:"\\0025cb   "}.lst-kix_2qpriag06n47-6>li:before{content:"\\0025cf   "}.lst-kix_tplutrsqd04i-1>li:before{content:"\\0025cb   "}.lst-kix_tplutrsqd04i-0>li:before{content:"\\0025cf   "}.lst-kix_tplutrsqd04i-2>li:before{content:"\\0025a0   "}.lst-kix_tplutrsqd04i-5>li:before{content:"\\0025a0   "}.lst-kix_tplutrsqd04i-4>li:before{content:"\\0025cb   "}.lst-kix_tplutrsqd04i-3>li:before{content:"\\0025cf   "}.lst-kix_2qpriag06n47-2>li:before{content:"\\0025a0   "}.lst-kix_eqnb7ujsk1ph-1>li{counter-increment:lst-ctn-kix_eqnb7ujsk1ph-1}.lst-kix_vq1lst5ovebp-1>li:before{content:"\\0025cb   "}.lst-kix_vq1lst5ovebp-0>li:before{content:"\\0025cf   "}ol.lst-kix_eqnb7ujsk1ph-1{list-style-type:none}ol.lst-kix_eqnb7ujsk1ph-0{list-style-type:none}.lst-kix_l7q7w09zmg89-8>li:before{content:"\\0025a0   "}ol.lst-kix_eqnb7ujsk1ph-2.start{counter-reset:lst-ctn-kix_eqnb7ujsk1ph-2 0}.lst-kix_l7q7w09zmg89-5>li:before{content:"\\0025a0   "}.lst-kix_l7q7w09zmg89-7>li:before{content:"\\0025cb   "}.lst-kix_l7q7w09zmg89-6>li:before{content:"\\0025cf   "}.lst-kix_fa9p7061r0a4-5>li:before{content:"\\0025a0   "}.lst-kix_nioq1cjfzb45-2>li:before{content:"\\0025a0   "}.lst-kix_fa9p7061r0a4-4>li:before{content:"\\0025cb   "}.lst-kix_fa9p7061r0a4-6>li:before{content:"\\0025cf   "}.lst-kix_nioq1cjfzb45-0>li:before{content:"\\0025cf   "}.lst-kix_nioq1cjfzb45-4>li:before{content:"\\0025cb   "}.lst-kix_nioq1cjfzb45-1>li:before{content:"\\0025cb   "}.lst-kix_nioq1cjfzb45-5>li:before{content:"\\0025a0   "}.lst-kix_fa9p7061r0a4-1>li:before{content:"\\0025cb   "}.lst-kix_fa9p7061r0a4-2>li:before{content:"\\0025a0   "}.lst-kix_fa9p7061r0a4-3>li:before{content:"\\0025cf   "}.lst-kix_lq8kuz2kjaxt-7>li:before{content:"\\0025cb   "}.lst-kix_nioq1cjfzb45-3>li:before{content:"\\0025cf   "}.lst-kix_lq8kuz2kjaxt-8>li:before{content:"\\0025a0   "}.lst-kix_eqnb7ujsk1ph-3>li{counter-increment:lst-ctn-kix_eqnb7ujsk1ph-3}ol.lst-kix_eqnb7ujsk1ph-8.start{counter-reset:lst-ctn-kix_eqnb7ujsk1ph-8 0}.lst-kix_nioq1cjfzb45-8>li:before{content:"\\0025a0   "}.lst-kix_nioq1cjfzb45-6>li:before{content:"\\0025cf   "}.lst-kix_fa9p7061r0a4-8>li:before{content:"\\0025a0   "}.lst-kix_fa9p7061r0a4-7>li:before{content:"\\0025cb   "}.lst-kix_nioq1cjfzb45-7>li:before{content:"\\0025cb   "}ul.lst-kix_1ep0gewysvhg-1{list-style-type:none}ul.lst-kix_1ep0gewysvhg-2{list-style-type:none}ul.lst-kix_1ep0gewysvhg-0{list-style-type:none}.lst-kix_xzhajfx04av1-1>li:before{content:"\\0025cb   "}.lst-kix_xzhajfx04av1-2>li:before{content:"\\0025a0   "}ul.lst-kix_1ep0gewysvhg-7{list-style-type:none}ul.lst-kix_1ep0gewysvhg-8{list-style-type:none}ul.lst-kix_1ep0gewysvhg-5{list-style-type:none}ul.lst-kix_1ep0gewysvhg-6{list-style-type:none}ul.lst-kix_1ep0gewysvhg-3{list-style-type:none}ol.lst-kix_eqnb7ujsk1ph-1.start{counter-reset:lst-ctn-kix_eqnb7ujsk1ph-1 0}ul.lst-kix_1ep0gewysvhg-4{list-style-type:none}.lst-kix_xzhajfx04av1-0>li:before{content:"\\0025cf   "}ul.lst-kix_tplutrsqd04i-3{list-style-type:none}.lst-kix_xzhajfx04av1-7>li:before{content:"\\0025cb   "}.lst-kix_2qpriag06n47-8>li:before{content:"\\0025a0   "}ul.lst-kix_tplutrsqd04i-4{list-style-type:none}ul.lst-kix_tplutrsqd04i-5{list-style-type:none}ul.lst-kix_tplutrsqd04i-6{list-style-type:none}.lst-kix_xzhajfx04av1-5>li:before{content:"\\0025a0   "}.lst-kix_2qpriag06n47-7>li:before{content:"\\0025cb   "}ul.lst-kix_tplutrsqd04i-0{list-style-type:none}ul.lst-kix_tplutrsqd04i-1{list-style-type:none}.lst-kix_xzhajfx04av1-6>li:before{content:"\\0025cf   "}ul.lst-kix_tplutrsqd04i-2{list-style-type:none}ol.lst-kix_eqnb7ujsk1ph-7.start{counter-reset:lst-ctn-kix_eqnb7ujsk1ph-7 0}.lst-kix_xzhajfx04av1-3>li:before{content:"\\0025cf   "}ul.lst-kix_tplutrsqd04i-7{list-style-type:none}ul.lst-kix_tplutrsqd04i-8{list-style-type:none}.lst-kix_xzhajfx04av1-4>li:before{content:"\\0025cb   "}.lst-kix_bpw8b05xh6bg-4>li:before{content:"\\0025cb   "}.lst-kix_eqnb7ujsk1ph-5>li{counter-increment:lst-ctn-kix_eqnb7ujsk1ph-5}.lst-kix_bpw8b05xh6bg-2>li:before{content:"\\0025a0   "}.lst-kix_bpw8b05xh6bg-6>li:before{content:"\\0025cf   "}ol.lst-kix_eqnb7ujsk1ph-0.start{counter-reset:lst-ctn-kix_eqnb7ujsk1ph-0 0}.lst-kix_eqnb7ujsk1ph-3>li:before{content:"" counter(lst-ctn-kix_eqnb7ujsk1ph-3,decimal) ". "}.lst-kix_xzhajfx04av1-8>li:before{content:"\\0025a0   "}.lst-kix_eqnb7ujsk1ph-1>li:before{content:"" counter(lst-ctn-kix_eqnb7ujsk1ph-1,lower-latin) ". "}.lst-kix_bpw8b05xh6bg-8>li:before{content:"\\0025a0   "}.lst-kix_eqnb7ujsk1ph-4>li{counter-increment:lst-ctn-kix_eqnb7ujsk1ph-4}.lst-kix_eqnb7ujsk1ph-6>li{counter-increment:lst-ctn-kix_eqnb7ujsk1ph-6}.lst-kix_qiqwh2x6bomx-7>li:before{content:"\\0025cb   "}.lst-kix_eqnb7ujsk1ph-7>li:before{content:"" counter(lst-ctn-kix_eqnb7ujsk1ph-7,lower-latin) ". "}.lst-kix_lq8kuz2kjaxt-5>li:before{content:"\\0025a0   "}.lst-kix_bpw8b05xh6bg-0>li:before{content:"\\0025cf   "}.lst-kix_fa9p7061r0a4-0>li:before{content:"\\0025cf   "}.lst-kix_lq8kuz2kjaxt-3>li:before{content:"\\0025cf   "}.lst-kix_eqnb7ujsk1ph-5>li:before{content:"" counter(lst-ctn-kix_eqnb7ujsk1ph-5,lower-roman) ". "}.lst-kix_lq8kuz2kjaxt-1>li:before{content:"\\0025cb   "}.lst-kix_9jjzf7tnl3tp-6>li:before{content:"\\0025cf   "}.lst-kix_l7q7w09zmg89-0>li:before{content:"\\0025cf   "}.lst-kix_l7q7w09zmg89-4>li:before{content:"\\0025cb   "}.lst-kix_qiqwh2x6bomx-3>li:before{content:"\\0025cf   "}.lst-kix_1ep0gewysvhg-1>li:before{content:"\\0025cb   "}.lst-kix_9jjzf7tnl3tp-0>li:before{content:"\\0025cf   "}.lst-kix_9jjzf7tnl3tp-8>li:before{content:"\\0025a0   "}.lst-kix_qiqwh2x6bomx-5>li:before{content:"\\0025a0   "}.lst-kix_l7q7w09zmg89-2>li:before{content:"\\0025a0   "}.lst-kix_1ep0gewysvhg-7>li:before{content:"\\0025cb   "}.lst-kix_vq1lst5ovebp-2>li:before{content:"\\0025a0   "}.lst-kix_1ep0gewysvhg-3>li:before{content:"\\0025cf   "}.lst-kix_1ep0gewysvhg-5>li:before{content:"\\0025a0   "}.lst-kix_qiqwh2x6bomx-1>li:before{content:"\\0025cb   "}.lst-kix_vq1lst5ovebp-4>li:before{content:"\\0025cb   "}.lst-kix_vq1lst5ovebp-6>li:before{content:"\\0025cf   "}li.li-bullet-0:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}.lst-kix_vq1lst5ovebp-8>li:before{content:"\\0025a0   "}ul.lst-kix_l7q7w09zmg89-8{list-style-type:none}ul.lst-kix_l7q7w09zmg89-7{list-style-type:none}ul.lst-kix_l7q7w09zmg89-4{list-style-type:none}ul.lst-kix_l7q7w09zmg89-3{list-style-type:none}ul.lst-kix_l7q7w09zmg89-6{list-style-type:none}ul.lst-kix_l7q7w09zmg89-5{list-style-type:none}ul.lst-kix_l7q7w09zmg89-0{list-style-type:none}.lst-kix_9jjzf7tnl3tp-2>li:before{content:"\\0025a0   "}ul.lst-kix_l7q7w09zmg89-2{list-style-type:none}ul.lst-kix_l7q7w09zmg89-1{list-style-type:none}.lst-kix_9jjzf7tnl3tp-4>li:before{content:"\\0025cb   "}ol{margin:0;padding:0}table td,table th{padding:0}.c1{margin-left:36pt;padding-top:0pt;padding-left:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c3{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left;height:11pt}.c10{padding-top:0pt;padding-bottom:16pt;line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c8{color:#b45f06;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:18pt;font-family:"Arial";font-style:normal}.c2{color:#666666;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:15pt;font-family:"Arial";font-style:normal}.c13{padding-top:0pt;padding-bottom:3pt;line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c0{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Arial";font-style:normal}.c14{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:center}.c7{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c12{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:justify}.c15{font-size:11pt;font-family:"Proxima Nova";color:#353744;font-weight:400}.c11{background-color:#ffffff;max-width:451.4pt;padding:72pt 72pt 72pt 72pt}.c9{color:#38761d;font-size:16pt}.c6{padding:0;margin:0}.c4{font-weight:700}.c5{font-style:italic}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Arial"}p{margin:0;color:#000000;font-size:11pt;font-family:"Arial"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}',
        }}
      />
      <p className="c13 title" id="h.mswncehf5h5v">
        <span className="c8">Visualizando e Administrando Transações Financeiras</span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c10 subtitle" id="h.q5fxk8viwfbr">
        <span className="c2">
          <br />
          Introdução:
        </span>
      </p>
      <p className="c12">
        <span className="c0">
          Neste tutorial, vamos explorar como visualizar e administrar as transações financeiras em nosso sistema. Siga
          os passos abaixo para acessar as transações e gerenciá-las.
        </span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c10 subtitle" id="h.wg48834rao9w">
        <span className="c2">
          <br />
          Seção 1: Acesso às Transações
        </span>
      </p>
      <p className="c7">
        <span className="c0">Para visualizar as transações, siga os seguintes passos:</span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <ol className="c6 lst-kix_eqnb7ujsk1ph-0 start" start={1}>
        <li className="c1 li-bullet-0">
          <span className="c0">Acesse o menu principal.</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">Clique na opção "Transações".</span>
        </li>
      </ol>
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c14">
        <Image
          src={`${process.env.PUBLIC_URL}/assets/images/image3.png`}
          style={{
            width: '522.50px',
            height: '280.84px',
            marginLeft: '0.00px',
            marginTop: '0.00px',
            transform: 'rotate(0.00rad) translateZ(0px)',
            WebkitTransform: 'rotate(0.00rad) translateZ(0px)',
          }}
        />
        {/* <span
          style={{
            overflow: 'hidden',
            display: 'inline-block',
            margin: '0.00px 0.00px',
            border: '0.00px solid #000000',
            transform: 'rotate(0.00rad) translateZ(0px)',
            WebkitTransform: 'rotate(0.00rad) translateZ(0px)',
            width: '601.70px',
            height: '169.33px',
          }}
        >
          <img
            alt=""
            src={`${process.env.PUBLIC_URL}/assets/images/image2.png`}
            style={{
              width: '601.70px',
              height: '169.33px',
              marginLeft: '0.00px',
              marginTop: '0.00px',
              transform: 'rotate(0.00rad) translateZ(0px)',
              WebkitTransform: 'rotate(0.00rad) translateZ(0px)',
            }}
            title
          />
        </span> */}
        <span className="c0">
          <br />
        </span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c10 subtitle" id="h.utzi59fehs6m">
        <span className="c2">
          <br />
          Seção 2: Tabela de Transações
        </span>
      </p>
      <p className="c7">
        <span className="c0">Na tabela de transações, você encontrará as seguintes colunas:</span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <ul className="c6 lst-kix_tplutrsqd04i-0 start">
        <li className="c1 li-bullet-0">
          <span className="c4">Ordem ID:</span>
          <span className="c0">&nbsp;O identificador do pedido no PagBank (Pagseguro).</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c4">Cliente:</span>
          <span className="c0">&nbsp;O nome do pagador.</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c4">Data de Criação da Transação:</span>
          <span className="c0">&nbsp;O momento em que a transação foi registrada no sistema.</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c4">Método de Pagamento:</span>
          <span className="c0">&nbsp;Pode ser Cartão de Crédito, Boleto ou Pix.</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c4">Item:</span>
          <span className="c0">&nbsp;O nome do item.</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c4">Total:</span>
          <span className="c0">&nbsp;O valor total do pedido.</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c4">Cobranças:</span>
          <span>&nbsp;A situação/"</span>
          <span className="c5">status"</span>
          <span className="c0">&nbsp;atual do pedido.</span>
        </li>
      </ul>
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c10 subtitle" id="h.ikp8jh8wko8">
        <span className="c2">
          <br />
          Seção 3: Detalhes da Transação
        </span>
      </p>
      <p className="c7">
        <span>Para abrir os detalhes de uma transação, clique no ícone </span>
        <span className="c4">"+"</span>
        <span className="c0">.</span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c14">
        <Image
          src={`${process.env.PUBLIC_URL}/assets/images/image2.png`}
          style={{
            width: '601.70px',
            height: '358.67px',
            marginLeft: '0.00px',
            marginTop: '0.00px',
            transform: 'rotate(0.00rad) translateZ(0px)',
            WebkitTransform: 'rotate(0.00rad) translateZ(0px)',
          }}
        />
        {/* <span
          style={{
            overflow: 'hidden',
            display: 'inline-block',
            margin: '0.00px 0.00px',
            border: '0.00px solid #000000',
            transform: 'rotate(0.00rad) translateZ(0px)',
            WebkitTransform: 'rotate(0.00rad) translateZ(0px)',
            width: '601.70px',
            height: '358.67px',
          }}
        >
          <img
            alt=""
            src={`${process.env.PUBLIC_URL}/assets/images/image3.png`}
            style={{
              width: '601.70px',
              height: '358.67px',
              marginLeft: '0.00px',
              marginTop: '0.00px',
              transform: 'rotate(0.00rad) translateZ(0px)',
              WebkitTransform: 'rotate(0.00rad) translateZ(0px)',
            }}
            title
          />
        </span> */}
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c7">
        <span className="c0">Nos detalhes da transação, na seção "Reembolso/Cancelamento", você pode:</span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <ul className="c6 lst-kix_fa9p7061r0a4-0 start">
        <li className="c1 li-bullet-0">
          <span className="c0">Realizar um reembolso parcial, inserindo o valor e clicando em "Reembolsar".</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">Cancelar o pagamento (estornar o valor total) clicando em "Cancelar Pagamento".</span>
        </li>
      </ul>
      <p className="c12">
        <span className="c0">
          <br />
          Observe que essa operação é irreversível. Uma mensagem de confirmação será exibida para o administrador
          confirmar o reembolso ou cancelamento.
        </span>
      </p>
      <br />
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c14">
        <Image
          src={`${process.env.PUBLIC_URL}/assets/images/image4.png`}
          style={{
            width: '522.50px',
            height: '280.84px',
            marginLeft: '0.00px',
            marginTop: '0.00px',
            transform: 'rotate(0.00rad) translateZ(0px)',
            WebkitTransform: 'rotate(0.00rad) translateZ(0px)',
          }}
        />
        {/* <span
          style={{
            overflow: 'hidden',
            display: 'inline-block',
            margin: '0.00px 0.00px',
            border: '0.00px solid #000000',
            transform: 'rotate(0.00rad) translateZ(0px)',
            WebkitTransform: 'rotate(0.00rad) translateZ(0px)',
            width: '522.50px',
            height: '280.84px',
          }}
        >
          <img
            alt=""
            src={`${process.env.PUBLIC_URL}/assets/images/image4.png`}
            style={{
              width: '522.50px',
              height: '280.84px',
              marginLeft: '0.00px',
              marginTop: '0.00px',
              transform: 'rotate(0.00rad) translateZ(0px)',
              WebkitTransform: 'rotate(0.00rad) translateZ(0px)',
            }}
            title
          />
        </span> */}
      </p>
      <p className="c10 subtitle" id="h.y2po0cz72dpn">
        <span className="c2">
          <br />
          <br />
          Seção 4: Processamento de Reembolso
        </span>
      </p>
      <p className="c12">
        <span className="c0">
          Caso o administrador do sistema clique em "Sim", o pedido de estorno será enviado ao PagSeguro. No entanto,
          lembre-se de que essa operação não é instantânea. O sistema deve aguardar uma notificação do PagSeguro
          confirmando a conclusão da operação. Somente após a notificação, os valores e a situação da transação serão
          atualizados.
        </span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <p className="c10 subtitle" id="h.a27idk7sfrhi">
        <span className="c2">
          <br />
          Seção 5: Status das Transações
        </span>
      </p>
      <p className="c7">
        <span className="c0">As transações podem ter os seguintes estados:</span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <ul className="c6 lst-kix_qiqwh2x6bomx-0 start">
        <li className="c1 li-bullet-0">
          <span className="c0">AUTORIZADO</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">PAGO</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">EM ANÁLISE</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">AGUARDANDO</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">EXPIRADO</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">CANCELADO</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">NEGADO</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">N/A (quando o pedido não possui uma transação associada)</span>
        </li>
      </ul>
      <p className="c7">
        <span>
          <br />
        </span>
        <span className="c4">Observação:</span>
        <span className="c0">
          &nbsp;Após a concretização da transação, o pedido pode ter os seguintes estados pós-transacionais:
        </span>
      </p>
      <p className="c3">
        <span className="c0" />
      </p>
      <ul className="c6 lst-kix_nioq1cjfzb45-0 start">
        <li className="c1 li-bullet-0">
          <span className="c0">DISPONÍVEL</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">EM DISPUTA</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">DEVOLVIDO</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">DEBITADO</span>
        </li>
        <li className="c1 li-bullet-0">
          <span className="c0">RETENÇÃO TEMPORÁRIA</span>
        </li>
      </ul>
      <p className="c3">
        <span className="c0" />
      </p>
    </Modal>
  );
}
